import { put, call, takeLatest, takeEvery } from 'redux-saga/effects';

import AuthUtil from '../../AuthUtil';
import { BUSINESS_TRACKER } from '../../../components/global/Server/endpoints';
import { hideError, showErrorMessage } from '../../actions/global';
import {
    LIST_TRACKER_ACCOUNTS,
    SAVE_TRACKER_ACCOUNT,
    DELETE_TRACKER_ACCOUNT,
    SAVE_TRACKER_CELL,
} from '../../constants/businessTracker';
import {
    storeTrackerAccounts,
    storeTrackerAccount,
    removeTrackerAccount,
} from '../../actions/businessTracker';
import { SERVER_FAILED_ERROR_MESSAGE } from '../../../components/dashboard/constants';

function* listAccountsSaga(action) {
    try {
        const response = yield call(() =>
            AuthUtil.postRequest(BUSINESS_TRACKER.LIST_ACCOUNTS, action.data),
        );
        if (response.status === 200 && response.data.success) {
            yield put(storeTrackerAccounts(response.data.accounts || []));
        }
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}

function* saveAccountSaga(action) {
    yield put(hideError());
    try {
        const response = yield call(() =>
            AuthUtil.postRequest(BUSINESS_TRACKER.SAVE_ACCOUNT, action.data),
        );
        if (response.status === 200 && response.data.success) {
            if (response.data.account) {
                yield put(storeTrackerAccount(response.data.account));
            }
            if (typeof action.callback === 'function') {
                action.callback(null, response.data.message);
            }
        } else {
            const message = response.data?.message || 'Save failed';
            if (typeof action.callback === 'function') {
                action.callback(message, null);
            }
            yield put(showErrorMessage(message));
        }
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
        if (typeof action.callback === 'function') {
            action.callback(SERVER_FAILED_ERROR_MESSAGE, null);
        }
    }
}

function* deleteAccountSaga(action) {
    yield put(hideError());
    try {
        const response = yield call(() =>
            AuthUtil.postRequest(BUSINESS_TRACKER.DELETE_ACCOUNT, action.data),
        );
        if (response.status === 200 && response.data.success) {
            yield put(
                removeTrackerAccount(
                    response.data.accountId || action.data.accountId,
                ),
            );
            if (typeof action.callback === 'function') {
                action.callback(null, response.data.message);
            }
        } else {
            const message = response.data?.message || 'Delete failed';
            if (typeof action.callback === 'function') {
                action.callback(message, null);
            }
            yield put(showErrorMessage(message));
        }
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
        if (typeof action.callback === 'function') {
            action.callback(SERVER_FAILED_ERROR_MESSAGE, null);
        }
    }
}

function* saveCellSaga(action) {
    yield put(hideError());
    try {
        const response = yield call(() =>
            AuthUtil.postRequest(BUSINESS_TRACKER.SAVE_CELL, action.data),
        );
        if (response.status === 200 && response.data.success) {
            if (response.data.account) {
                yield put(storeTrackerAccount(response.data.account));
            }
            if (typeof action.callback === 'function') {
                action.callback(null, response.data.message);
            }
        } else {
            const message = response.data?.message || 'Cell save failed';
            if (typeof action.callback === 'function') {
                action.callback(message, null);
            }
            yield put(showErrorMessage(message));
        }
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
        if (typeof action.callback === 'function') {
            action.callback(SERVER_FAILED_ERROR_MESSAGE, null);
        }
    }
}

export default function* businessTrackerSagas() {
    yield takeLatest(LIST_TRACKER_ACCOUNTS, listAccountsSaga);
    yield takeEvery(SAVE_TRACKER_ACCOUNT, saveAccountSaga);
    yield takeEvery(DELETE_TRACKER_ACCOUNT, deleteAccountSaga);
    yield takeEvery(SAVE_TRACKER_CELL, saveCellSaga);
}
